import { useLinked } from "@linked/react/lib";
import { styled } from "@material-ui/core";
import { Button, div, PopupDialog, PrimaryButton } from "lqx-react/lib";
import React from "react";
import { GlobalFieldSelectionSection } from "./global-field-selection-section";

export const GlobalFieldSelectionPopup = ({ onClose }
  : { onClose: any }) => {
  const $mapTo = useLinked({ id: 1, name: 'Below' });
  return (
    <>
      <GlobalFieldSelectionPopupDialog title=''>
        <GlobalFieldSelectionSection $mapTo={$mapTo}></GlobalFieldSelectionSection>
        <ButtonSection>
          <PrimaryButton onClick={() => onClose($mapTo.value.name)}>
            Apply
          </PrimaryButton>
          <Button onClick={() => onClose()}>
            Cancel
          </Button>
        </ButtonSection>
      </GlobalFieldSelectionPopupDialog>
    </>
  );
};

const GlobalFieldSelectionPopupDialog = styled(PopupDialog)({
  '& .MuiDialog-paperFullWidth': {
    width: '350px',
  }
});

const ButtonSection = div({
  marginTop: '60px',
  marginLeft: '70px',
});

